/* @ngInject */
function BriefingInputController ($scope) {
  $scope.getVariations = function () {
    return 'fluid' + (($scope.readOnly) ? ' disabled' : '')
  }
}

export { BriefingInputController }
